import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {isInitedSelector} from '../../modules/app'
import {isAuthSelector, isOrganisationSelector, isTeacherOrganisationSelector} from '../../modules/profile'
import {routesUrls} from '../../settings/routes'



const isRouter = (routers, path) => {
    return routers.some(route => path.indexOf(route) > -1)
}


const componentAuth = (Component, props, isTeacherOrganisation, permission) => {

    const routes = ['/questions', '/profile', '/payment', '/support', '/question_import'];

    if(permission){
        if(permission.classrooms){
            routes.push('/rooms_students');
            routes.push('/students');
        }
        if(permission.quizzes){
            routes.push('/quiz')
            routes.push('/quizs')
        }
        if(permission.statistics){
            routes.push('/statistic_reports')
            routes.push('/student/answer/quiz/')
        }
        if(permission.lecture_hall){
            routes.push('/presentations')
            routes.push('/presentation')
            routes.push('/presentations_start')
        }
        if(permission.flash_card){
            routes.push('/cards')
            // routes.push('/presentation')
            // routes.push('/presentations_start')
        }
    }

    if(isTeacherOrganisation && props.location.pathname != '/' && !isRouter(routes, props.location.pathname) ){
        return <Redirect to={{
            pathname: '/',
        }}/>
    }

    return  <Component {...props}/>
}


const AuthRoute = ({ isInited, isAuth, isOrganisation, permission, isTeacherOrganisation, component: Component, ...rest }) => {
    if (!isInited) return <Route {...rest} render={props => (<Component {...props} />)} />

    return (
        <Route {...rest} render={props => (
            ( isAuth ) ? componentAuth(Component, props, isTeacherOrganisation, permission) : (
                <Redirect to={{
                    pathname: routesUrls.login,
                    state: { from: props.location }
                }}/>
            )
        )}/>
    )
}

export default connect(
    state=>({
        isInited : isInitedSelector(state),
        isAuth : isAuthSelector(state),
        permission: state.profile.permission || {},
        isOrganisation : isOrganisationSelector(state),
        isTeacherOrganisation : isTeacherOrganisationSelector(state),
    }),
    null,
    null,
    {pure:false}
)(AuthRoute)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/AuthRoute.js